import { useApolloClient, useQuery } from '@apollo/client';
import { Trans } from '@lingui/react/macro';
import type { MenuProps } from 'antd';
import { Button } from 'antd';
import _get from 'lodash/get';
import React from 'react';
import { Link } from 'react-router-dom';

import { GET_LOGGED_IN_USER } from 'graphql/queries';
/** Custom imports */
import { PlayCircleOutlined } from '@ant-design/icons';
import { ReactComponent as Avatar } from 'assets/icons/Meteo_Log-out.svg';
import { SettingsModal } from 'components/elements/SettingsModal';
import { isLoggedInVar } from 'utils/cache';

import { StyledLogoutIcon, StyledMenu } from './style';

export const HorizontalMenu = () => {
  const { data: user } = useQuery(GET_LOGGED_IN_USER);
  const username = _get(user, 'me.username');
  const client = useApolloClient();

  const handleLogout = () => {
    client.cache.evict({ fieldName: 'me' });
    client.cache.gc();

    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('remember');

    isLoggedInVar(false);
  };

  const items: MenuProps['items'] = [
    {
      key: '/tutorials',
      className: 'horizontal-menu-tutorials',
      label: (
        <Link to="/tutorials">
          <Trans>Manuals</Trans>
          <PlayCircleOutlined />
        </Link>
      ),
    },
    {
      key: 'user',
      className: 'horizontal-menu-user',
      icon: <Avatar />,
      label: username,
      children: [
        {
          key: 'logout',
          label: (
            <Button type="link" onClick={handleLogout}>
              <Trans>
                Log out <StyledLogoutIcon />
              </Trans>
            </Button>
          ),
        },
        {
          key: 'settings',
          label: <SettingsModal />,
        },
      ],
    },
  ];

  return (
    <StyledMenu
      mode="horizontal"
      items={items}
      selectable={false}
      disabledOverflow
    />
  );
};
